import { render, staticRenderFns } from "./KycTab.vue?vue&type=template&id=bde2b5ca&scoped=true"
import script from "./KycTab.vue?vue&type=script&lang=js"
export * from "./KycTab.vue?vue&type=script&lang=js"
import style0 from "./KycTab.vue?vue&type=style&index=0&id=bde2b5ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde2b5ca",
  null
  
)

export default component.exports